import { Injectable } from '@angular/core';
import * as io from 'socket.io-client';

@Injectable()

export class ChatService {
  // private socket = io('http://socket.ask4token.com:1705?username=parin&type=user');

  // connect() {
  //   this.socket.on('connect', function () {
  //     console.log("Socket Connected!");
  //   });
    
  // //   this.socket.emit('message', {
  // //     from: 'parin',
  // //     to: '9909277305',
  // //     msg: 'Hi.. Test Message'
  // // });
  
  // //   this.socket.on('message', (data) => {
  // //     console.log(data);
  // //   });

  // //   this.socket.on('disconnect', function () {
  // //     console.log("Socket Disconnected!");
  // //   });
  // }

  // sendMessage(data) {
  //   this.socket.emit('message', {
  //     from: 'parin',
  //     to: 'parin',
  //     msg: data
  //   });

  //   this.socket.on('message', (data) => {
  //     console.log(data);
  //   });
  // }
}
